
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";
import Uploadimg from "@/components/uploadimg/Index.vue";
import { useStore } from "vuex";
import { ElForm } from "element-plus";
 import Uploadfile from "@/components/uploadfile/Index.vue";
  import Uploadvideo from "@/components/uploadvideo/Index.vue";
import { addMessage } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增留言",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg,Uploadfile,Uploadvideo,
  },
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    let isEdit = false;
    let show = opt.open;
    const store = useStore();

    const dataMap: any = reactive({
      messageType:'',
      ruleForm: {
        content: "",
        fileId:'',
        contentType:'',
        title:'',
        fileName: "",
        orgLogo:'',
        orgLogoName:'',
      },
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
         contentType: [
          { required: true, message: "请输选择留言类型", trigger: "blur" },
        ],
      },

      async putNewData() {
        const res = await addMessage(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
       async getEnumType() {
        dataMap.messageType = {};
        const menus = await getEnum("MESSAGE");
        for (const item of menus.data) {
          dataMap.messageType[item.enumKey] = item;
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
      if(opt.row.fileName) dataMap.ruleForm.fileUrl =  localStorage.getItem("fileUrel") + opt.row.fileName;
      if(opt.row.orgLogoName) dataMap.ruleForm.orgLogoName =  localStorage.getItem("fileUrel") + opt.row.orgLogoName;
      if(dataMap.ruleForm.contentType=='MESSAGE_LETTER'&&dataMap.ruleForm.content) dataMap.ruleForm.content= localStorage.getItem("fileUrel") + opt.row.content;
    }

    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
          dataMap.putNewData();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const close = () => {
      const form = unref(ruleFormRef);
      contex.emit("close", false);
    };

    const onSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
      dataMap.ruleForm.fileName = val.fileName;
    };
    const orgSuccess = (val: any) => {
      dataMap.ruleForm.orgLogo = val.id;
      dataMap.ruleForm.orgLogoName = val.fileName;
    };
    const xinSuccess = (val: any) => {
      dataMap.ruleForm.content = val.fileName;
    };
    
    const fileSuccess = (val: any) => {
      if( val.value.length){
         dataMap.ruleForm.content = val.value[0].fileName;
        } else{
          dataMap.ruleForm.content= '';
        }  
    };

   const selectChange = () => {
      dataMap.ruleForm.content = '';
    }; 

 
 
 
  
    onMounted(() => {
      dataMap.getEnumType();
    });
    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      onSuccess,
      orgSuccess,
      fileSuccess,
      xinSuccess,
      selectChange,
      close,
      ...toRefs(dataMap),
    };
  },
});
